import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, unref as _unref, toDisplayString as _toDisplayString, Fragment as _Fragment } from "vue"

import { ref,getCurrentInstance } from 'vue'
import Keys from '@/constant/key'
import { useStore } from '@/store/index'

export default /*@__PURE__*/_defineComponent({
  __name: 'CouponInfo',
  setup(__props) {

const store = useStore()
const { proxy } = getCurrentInstance() as any

const dialogVisible = ref<Boolean>(false)
const file = ref<File | null>(null);
const url = ref<string>('')

const dialogBeforeClose = () => {
    proxy.$refs.upload.clearFiles()
    dialogVisible.value = false
}

const clearFile = () => {
    file.value = null;
    url.value = ''
}
const handleFileChange = (newFile) => {
    file.value = newFile.raw
}

const handleFileSuccess = (res) => {
    if(res.code == '200'){
        proxy.$message({
            type: 'success',
            message: res.msg
        })
    url.value =  res.data.url
    }else{
        proxy.$message({
            type: 'error',
            message: res.msg
        })
    }
    dialogVisible.value = false;
    file.value = null;
}
const submitUpload = () => {
    proxy.$refs.upload.submit()
}

const onExport = () => {
    window.open(`${url.value}`)
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_card, {
      class: "mb15",
      shadow: "hover"
    }, {
      header: _withCtx(() => _cache[3] || (_cache[3] = [
        _createElementVNode("div", {
          class: "card-header",
          style: {"font-size":"14px","font-weight":"bold"}
        }, [
          _createElementVNode("span", null, "电子券订单信息")
        ], -1)
      ])),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          inline: true,
          class: "filter-form"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (dialogVisible.value=true)),
                  class: "export-btn",
                  disabled: url.value !== ''
                }, {
                  default: _withCtx(() => _cache[4] || (_cache[4] = [
                    _createTextVNode("批量上传券码")
                  ])),
                  _: 1
                }, 8, ["disabled"]),
                (url.value)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      onClick: clearFile,
                      style: {"color":"#409eff","position":"absolute","top":"28px","left":"34px","font-size":"12px"}
                    }, "清除"))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: onExport,
                  class: "export-btn",
                  style: _normalizeStyle(url.value ? { 'margin-left': '20px' } : {})
                }, {
                  default: _withCtx(() => _cache[5] || (_cache[5] = [
                    _createTextVNode("导出")
                  ])),
                  _: 1
                }, 8, ["style"]),
                _cache[6] || (_cache[6] = _createElementVNode("div", { class: "export-note" }, "注：根据电子券券码、名称，导出电子券订单号和支付日期", -1))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_dialog, {
      title: "批量上传券码",
      modelValue: dialogVisible.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((dialogVisible).value = $event)),
      "before-close": dialogBeforeClose
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, { onClick: dialogBeforeClose }, {
          default: _withCtx(() => _cache[9] || (_cache[9] = [
            _createTextVNode("取 消")
          ])),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (submitUpload()))
        }, {
          default: _withCtx(() => _cache[10] || (_cache[10] = [
            _createTextVNode("确 定")
          ])),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, { "label-width": "80px" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "上传文件" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_upload, {
                  ref: "upload",
                  action: `/api/admin/coupons/get_coupon_order?user_id=${ _unref(store).state.user.userInfo.id }`,
                  "show-file-list": false,
                  "on-success": handleFileSuccess,
                  "on-change": handleFileChange,
                  "auto-upload": false
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      size: "small"
                    }, {
                      default: _withCtx(() => _cache[7] || (_cache[7] = [
                        _createTextVNode("点击上传")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["action"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createElementVNode("div", null, _toDisplayString(file.value?.name), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_link, {
                  href: `${_unref(Keys).baseUrl}/admin/coupons/get_coupon_template`,
                  type: "primary"
                }, {
                  default: _withCtx(() => _cache[8] || (_cache[8] = [
                    _createTextVNode("下载批量添加模版")
                  ])),
                  _: 1
                }, 8, ["href"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})